export const PRODUCT_DATA = {
  productName: "Barilla Protein+ Fortified Pasta",
  productImage: "https://placehold.co/600x400/EEE/31343C?text=Product+Mock-up.%0AReserved+for+v.2.0",
  marketOpportunity: {
    costReduction: "16%",
    marketValue: "$112M",
  },
  consumerFeedback: [
    {
      category: "Taste",
      rating: "9/10",
      feedback: "Umami-rich flavor matches or exceeds classic pasta"
    },
    {
      category: "Texture",
      rating: "8/10",
      feedback: "Slightly firmer, denser bite, still al dente mouthfeel"
    },
    {
      category: "Appearance",
      rating: "8/10",
      feedback: "Cream-beige hue with fine flecks, artisan-looking"
    },
    {
      category: "Willingness to buy",
      rating: "9/10",
      feedback: "10 g protein per serving, no price increase"
    }
  ],

  formulation: {
    originalIngredients:
      "Semolina (Wheat), Durum Wheat Flour, Vitamins and Minerals",
    replacementIngredients:
      "47% Semolina replaced by liquid brewer’s spent yeast (30% solids; 50% protein in solids)",
    functionalImprovements: "Maintains extrusion rheology and drying profile",
    nutritionalImprovements: {
      protein: "↑ 43% (7 g → 10 g per 56 g serving)"
    },
  },

  marketInformation: [
    { attribute: "Product Pack Size", details: "16 oz (454g)" },
    { attribute: "Average Price, $", details: "~$1.94" },
    { attribute: "US Sales Volume, $", details: "~$800 Million" },
    { attribute: "Price Elasticity", details: "-0.88 (Inelastic)" }
  ],

  supplyAvailability: {
    byproduct: "Spent brewer’s yeast",
    volume: "~ 85 000 t",
    driedPastaOutput: "Enough for 70% extension",
    suppliers: [
      "Anheuser-Busch InBev",
      "Molson Coors",
      "Boston Beer Co.",
      "Sierra Nevada Brewing Co."
    ]
  },

  processingSteps: "Yeast collection: Partner with breweries to collect their spent yeast slurry. Centrifugation: Concentrate the slurry. Holding: Store the concentrated spent brewer’s yeast in insulated tanks. Blending: Meter the yeast into the semolina stream. Extrusion & drying: Use existing Barilla Classic pasta lines without modification."
};
